import { stdObject } from "../data/types/stdObject";

export const validFormat = (value: string, params: stdObject) => {
  let results: stdObject = {
    success: true,
    errorTypes: [],
    value,
  };
  try {
    if (value.length === 0) {
      results.errorTypes.push("isEmpty");
    } else {
      Object.keys(params).forEach((e: string) => {
        if (params[e]) {
          let errorDetected = false;
          switch (e) {
            case "minLength":
              errorDetected = value.length < params[e];
              break;
            case "maxLength":
              errorDetected = value.length > params[e];
              break;
            case "noSpecials":
              errorDetected = /[^a-zA-Z0-9\s]/.test(value);
              break;
            case "noSpaces":
              errorDetected = !/^\S*$/.test(value);
              break;
            case "email":
              errorDetected =
                !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
              break;
          }
          if (errorDetected) {
            results.errorTypes.push(e);
          }
        }
      });
    }
  } catch (error) {
    console.log("validFormat error: ", error);
  }
  results.success = results.errorTypes.length === 0;
  return results;
};
